import { useParams } from "react-router-dom";
import { useLocales } from "../../hooks";
import { useState } from "react";
import { isExists, params } from "../../utils";
import { useGetListQuery } from "../../features/api/Api";
import { GridColDef } from "@mui/x-data-grid";
import {
  List,
  ListRefPreviewButton,
  MuiDatagrid,
  RefField,
} from "../../components";
import { defaultToolbar } from "../../components/views/datagrid/MuiDatagrid";

const CustomerWorkOrderDetailDocument = () => {
  const { translate } = useLocales();
  const { id } = useParams();
  const [documentParams, setWorkOrderDocumentParams] = useState<any>({
    resource: "fixity/workorder/document",
    params: { ...params, filter: { workOrderId: id } },
  });

  const { data: workOrderDocuments, isLoading } =
    useGetListQuery<any>(documentParams);

  const columns: GridColDef[] = [
    {
      field: "documentId",
      headerName: translate("resources.workOrders.file_name"),
      flex: 1,
      renderCell: ({ value }) => (
        <RefField
          data={value}
          reference="fixity/document/file"
          optionname="fileName"
        />
      ),
    },
    {
      field: "description",
      headerName: translate("resources.workOrders.description"),
      flex: 1,
    },

    {
      field: "actions",
      headerName: "",
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      hideSortIcons: true,
      sortable: false,
      align: "center",
      width: 100,
      renderCell: (params: any) => (
        <ListRefPreviewButton id={params.row.documentId} />
      ),
    },
  ];

  return (
    <List
      tableName={translate("resources.workOrders.document_list")}
      loading={isLoading}
    >
      <MuiDatagrid
        loading={isLoading}
        rows={isExists(workOrderDocuments) ? workOrderDocuments.data : []}
        columns={columns}
        rowCount={workOrderDocuments?.totalItemCount}
        pageSize={documentParams.params.pagination.size}
        pageNumber={documentParams.params.pagination.pageNumber}
        setPagination={setWorkOrderDocumentParams}
        hideToolbars={{ ...defaultToolbar, create: false }}
      />
    </List>
  );
};
export default CustomerWorkOrderDetailDocument;
